import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function Popup({
    isOpen = false,
    title,
    content,
    closeAction,
}) {
  return (
      <Dialog
        open={isOpen}
        onClose={()=> closeAction()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
              {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=> closeAction()}>Close</Button>
        </DialogActions>
      </Dialog>
  );
}
